import React, { useState, useEffect, useRef } from 'react';
import { LoadingChatProps } from './props';
import '../../../../../css/loading.css';

const thinkingPhrases = [
  'Escribiendo...',
  'Pensando...',
  'Buscando información...',
  'Procesando datos...',
  'Generando respuesta...',
  'Analizando...',
  'Revisando datos...',
  'Verificando datos...',
  'Preparando respuesta...',
  'Creando respuesta...',
  'Ajustando la información...',
];

const LoadingChat = ({ isBotThinking }: LoadingChatProps) => {
  const [currentPhrase, setCurrentPhrase] = useState('');
  const intervalIdRef = useRef(null);

  useEffect(() => {
    if (isBotThinking) {
      const initialIndex = Math.floor(Math.random() * thinkingPhrases.length);
      setCurrentPhrase(thinkingPhrases[initialIndex]);

      intervalIdRef.current = setInterval(() => {
        const randomIndex = Math.floor(Math.random() * thinkingPhrases.length);
        setCurrentPhrase(thinkingPhrases[randomIndex]);
      }, 5000);

      return () => {
        if (intervalIdRef.current) {
          clearInterval(intervalIdRef.current);
        }
      };
    } else {
      setCurrentPhrase('');
      if (intervalIdRef.current) {
        clearInterval(intervalIdRef.current);
        intervalIdRef.current = null;
      }
    }
  }, [isBotThinking]);

  return (
    isBotThinking && (
      <div className="bot-thinking-container">
        <div className="bot-icon-rotating"></div>
        <div className="bot-thinking-fade">
          <span>{currentPhrase}</span>
        </div>
      </div>
    )
  );
};

export default LoadingChat;